
import { openDB } from 'idb';

const DB_NAME = 'sampleflow-offline';
const STORE_NAME = 'offline_queue';

// Simple IndexedDB Wrapper to "store-and-forward" actions
export const offlineDB = {
    // Init
    open: () => openDB(DB_NAME, 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
            }
        },
    }),

    // Add Action (e.g. { type: 'completePiece', payload: {...} })
    enqueue: async (action: string, payload: any) => {
        const db = await offlineDB.open();
        await db.add(STORE_NAME, { action, payload, createdAt: Date.now() });
    },

    // Get All Pending
    getAll: async () => {
        const db = await offlineDB.open();
        return db.getAll(STORE_NAME);
    },

    // Remove One (after sync)
    remove: async (id: number) => {
        const db = await offlineDB.open();
        await db.delete(STORE_NAME, id);
    },

    // Clear All
    clear: async () => {
        const db = await offlineDB.open();
        await db.clear(STORE_NAME);
    }
};
